<div class="table-view">
  <p-table
    [value]="loglist"
    dataKey="LogOn"
    [rows]="10"
    [paginator]="true"
    [rowsPerPageOptions]="[5, 10, 20]"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="{{ 'SUMMARY_TOTALRECORDS' | translate }}"
    (onRowExpand)="loadUsers($event.data)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th></th>
        <th>{{ "LOGIN_DATE" | translate }}</th>
        <th>{{ "LOGIN_COUNT" | translate }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-log let-expanded="expanded">
      <tr>
        <td width="60px">
          <button
            type="button"
            class="btn"
            [pRowToggler]="log"
            [attr.aria-expanded]="expanded"
            [attr.aria-label]="'USERNAME' | translate"
          >
            <i
              class="pi"
              [ngClass]="expanded ? 'pi-chevron-down' : 'pi-chevron-right'"
              aria-hidden="true"
            ></i>
          </button>
        </td>
        <td>{{ log.LogOn | date: "dd/MM/yyyy" }}</td>
        <td>{{ log.LoginCount }}</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="expandedrow" let-log>
      <tr>
        <td colspan="3">
          <p-table
            [value]="loginUsersByDay[log.LogOn] || []"
            [loading]="loadingDays[log.LogOn]"
          >
            <ng-template pTemplate="header">
              <tr>
                <th>{{ "USERNAME" | translate }}</th>
                <th>{{ "LOGIN_COUNT" | translate }}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
              <tr>
                <td>{{ user.Business || ("UNKNOWN" | translate) }}</td>
                <td>{{ user.LoginCount }}</td>
              </tr>
            </ng-template>
          </p-table>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="3">{{ "NO_RECORDS_FOUND" | translate }}</td>
      </tr>
    </ng-template>
  </p-table>
</div>
